import React from 'react';
import { FieldErrors } from 'react-hook-form';
import { findCodePrefix } from '../../../utils/codePrefixUtils';

interface CarCodePrefixFieldProps {
  selectedCodePrefix: string;
  carNumber: string;
  codePrefixes: any[];
  errors: FieldErrors<any>;
  onPrefixChange: (prefixId: string) => void;
  registerCode: React.InputHTMLAttributes<HTMLInputElement> & { ref: React.Ref<HTMLInputElement> };
}

const CarCodePrefixField: React.FC<CarCodePrefixFieldProps> = ({
  selectedCodePrefix,
  carNumber,
  codePrefixes,
  errors,
  onPrefixChange,
  registerCode
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Car Code
      </label>
      <div className="flex gap-2">
        <select
          value={selectedCodePrefix}
          onChange={(e) => onPrefixChange(e.target.value)}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        >
          <option value="">Select Code Prefix</option>
          {codePrefixes.map((prefix: any) => (
            <option key={prefix.id} value={prefix.id}>
              {prefix.prefix} - {prefix.name}
            </option>
          ))}
        </select>
      </div>
      {selectedCodePrefix && (
        <div className="mt-2 p-2 bg-gray-50 rounded-md border border-gray-200">
          <span className="text-sm text-gray-600">Generated Code: </span>
          <span className="text-sm font-semibold text-primary-600">
            {findCodePrefix(codePrefixes, selectedCodePrefix)?.prefix}{carNumber}
          </span>
        </div>
      )}
      <input type="hidden" {...registerCode} />
      {errors.code?.message && (
        <p className="mt-1 text-sm text-red-600">{errors.code.message as string}</p>
      )}
    </div>
  );
};

export default CarCodePrefixField;
